<div class="card" *blockUI="'section-block'">
    <div class="row">
        <div class="col-12 mb-50">

        </div>
        <div class="col-md-6 col-12">

            <div class="d-flex justify-content-between align-items-center m-1">
                <label class="d-flex align-items-center">
                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption"
                        (ngModelChange)="onOptionChange()">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="50">50</option>
                    </select>
                </label>
            </div>
        </div>

    </div>
    <ngx-datatable #tableRowDetails [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap"
        style="cursor: pointer;" [limit]="selectedSize" [messages]="{ 
      emptyMessage: 'Veri Yok',
      totalMessage: 'Toplam', 
      selectedMessage: 'Seçili'
    }" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true">

        <ngx-datatable-row-detail [rowHeight]="getRowHeight(row)">
            <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
                <div class="ml-75 pl-5 pt-75">
                    <div *ngFor="let action of row.actions">
                        <span><strong>No : </strong> {{ action?.no }}</span>
                        <span class="ml-1"><strong>Başlık :
                            </strong> {{ action?.title }}</span>
                        <span class="ml-1"><strong>Bitiş Tarihi : </strong>
                            {{ action?.finishActionDate | date : 'dd.MM.yyyy' }}
                        </span>
                    </div>
                </div>
            </ng-template>
        </ngx-datatable-row-detail>
        <ngx-datatable-column [width]="50" [resizeable]="false" [sortable]="false" [draggable]="false"
            [canAutoResize]="false">
            <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
                <a href="javascript:void(0)" [class.datatable-icon-right]="!expanded"
                    [class.datatable-icon-down]="expanded" title="Expand/Collapse Row"
                    (click)="rowDetailsToggleExpand(row)">
                </a>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="No" prop="no"></ngx-datatable-column>
        <ngx-datatable-column name="Başlık" prop="title"></ngx-datatable-column>
        <ngx-datatable-column name="Personel">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.personName}} {{ row.lastName}}
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Aksiyon Sayısı">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{row.actions?.length}}
            </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column  [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
                <button type="button" class="btn btn-flat-success" rippleEffect (click)="showCrateAksiyon(row)">
                    <span [data-feather]="'plus'" [class]="'mr-25'"></span>Aksiyon Ekle</button>
            </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>
                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event)">
                        <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'" [size]="18"
                                [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext><span [data-feather]="'chevron-right'" [size]="18"
                                [class]="'font-weight-bolder'"></span></ng-template>
                    </ngb-pagination>
                </div>

            </ng-template>

        </ngx-datatable-footer>
    </ngx-datatable>
</div>